exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multi-el-cascader-checkbox {\n  margin: 0;\n}\n.multi-el-cascader-checkbox .el-checkbox__input {\n  padding-right: 10px;\n}\n", ""]);

// exports
